import { Box, Typography } from '@mui/joy';
import { Trash } from '@phosphor-icons/react';
import { ICellRendererParams } from 'ag-grid-community';
import { t } from 'i18next';
import { useState } from 'react';

import { Confirmation } from 'core/components';
import { Color, Level } from 'theme/enums';

interface IProps extends ICellRendererParams {
  onRemove?: (value: unknown) => void;
  options?: {
    removeHasConfirmation?: boolean;
    removeTitle?: string;
    removeMessage?: string;
  };
}

export const ActionsCell = ({
  api,
  data,
  onRemove,
  options: {
    removeHasConfirmation = false,
    removeTitle = t('titleRemoveRow'),
    removeMessage = t('messageConfirmRemoveRow'),
  } = {},
}: IProps) => {
  const [isRemoving, setIsRemoving] = useState(false);

  const handleRemove = async () => {
    onRemove && onRemove(data);

    api.applyTransaction({ remove: [data] });
    setIsRemoving(false);
  };

  const onRemoveClick = () => {
    if (!removeHasConfirmation) {
      handleRemove();

      return;
    }

    setIsRemoving(true);
  };

  return (
    <>
      <Box sx={{ display: 'flex', gap: '8px' }}>
        <Typography
          color={Color.DANGER}
          level={Level.BODY_SM}
          onClick={onRemoveClick}
          sx={{ cursor: 'pointer' }}
        >
          <Trash />
        </Typography>
      </Box>
      <Confirmation
        isOpen={isRemoving}
        title={removeTitle}
        message={removeMessage}
        confirmBtnColor={Color.DANGER}
        onConfirm={handleRemove}
        onCancel={() => setIsRemoving(false)}
      />
    </>
  );
};
